import { FirebaseOptions } from "firebase/app";

import { env } from "./env";

const firebaseConfigs: FirebaseOptions = {
  apiKey: env.FIREBASE_API_KEY,
  authDomain: env.FIREBASE_AUTH_DOMAIN,
  projectId: env.FIREBASE_PROJECT_ID,
  storageBucket: env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: env.FIREBASE_MESSAGING_SENDER_ID,
  appId: env.FIREBASE_APP_ID,
};

function rabbitMqWsUrl(): string {
  const proto = window.location.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${window.location.host}/rabbitmq-ws/ws`;
}

export const config = {
  rabbitMqWsUrl: rabbitMqWsUrl(),
  firebase: firebaseConfigs,
  firebaseVapidKey: env.FIREBASE_VAPID_KEY,
};
